import React from 'react';
import { ArrowUpRight } from 'lucide-react';

export default function SiteHeader() {
  return <header style={styles.header}>
    <a href="/" style={styles.logo}><img src="/malluland.png" alt="Malluland" style={{ height: 34, width: 'auto', filter: 'invert(1)' }} /></a>
    <a href="https://www.instagram.com/mallulandonline/" target="_blank" rel="noopener noreferrer" style={styles.partnerLink}>Partner with us <ArrowUpRight size={16} /></a>
  </header>;
}

const styles = {
  header: { width: '100%', boxSizing: 'border-box', maxWidth: 1180, margin: '0 auto', padding: '1.25rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  logo: { display: 'inline-flex', alignItems: 'center' },
  partnerLink: { color: '#111', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 5, fontWeight: 600, fontSize: '0.9rem' },
};
